import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
//import { MovementNavigationPlanComponent } from '../../components/movements/movement-form/movement-navigation-plan/movement-navigation-plan.component';
//import { TranslateModule } from '@ngx-translate/core';
//import { CommonModule } from '@angular/common';
import { Boat, SlingConfig } from 'src/app/models';
import { MovementPlanByObjectiveCreateDTO } from 'src/app/models/dtos/movements/movement-plan-by-objective-createDTO';
//import { ContractLogComponent } from 'src/app/pages/logs/contract-log/contract-log.component';
import { ToastService } from 'src/app/services/toast.service'; 
import { MovementPlanService } from 'src/app/services/movements/movement-plan.service';
import { MovementExecutionService } from 'src/app/services/movements/movement-execution.service';
import { ExecuteOperationDTO } from 'src/app/models/dtos/movements/execute-operationDTO';
import { MovementOperation } from 'src/app/models/enums/movements/movement-operation';
import { LocationFinishDTO } from 'src/app/models/dtos/movements/location-finishDTO';
import { MovementLocationType } from 'src/app/models/enums/movements/movement-location-type';
import { MovementLocation } from 'src/app/models/movement/movement-location';

@Component({
  selector: 'app-berth-map-navigation-plan',
  templateUrl: './berth-map-navigation-plan.component.html',
  styleUrls: ['./berth-map-navigation-plan.component.scss']
  
})
export class BerthMapNavigationPlanComponent implements OnInit {
  
  
  
  destinations: string[] = [];
  frequentDestinations: {label: string, value: string}[] = [];
  isNew: boolean = true;
  hasNavigationPlan = true;
  movementPlan: MovementPlanByObjectiveCreateDTO;
  slingConfig: SlingConfig;
  // boatIdOnly = {id: 23411};
  minDateToExecutionDate = new Date();
  //form : FormGroup;
  objectiveSelected: any;
  boat: Boat;


  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private fb: FormBuilder,
    private toastService: ToastService,
    private movementPlanService: MovementPlanService,
    private movimentExecutionService: MovementExecutionService

  ) {
    const data = this.config.data;
    this.boat = data.boat;
    
    this.isNew = true;
     // data.isNew !== null || data.isNew !== undefined ? data.isNew : true;
    this.slingConfig = data.slingConfig;
    if (!this.isNew) {
      this.movementPlan = data.movementPlan;
    }

    this.hasNavigationPlan = true;
    this.movementPlan = new MovementPlanByObjectiveCreateDTO();
    this.movementPlan.boat = this.boat;
    
    console.log(this.boat);

     

  }

  ngOnInit(): void {

       


  }

  save(): void {
   
  }

  finish(event:MovementPlanByObjectiveCreateDTO): void {
    
    console.log(event);
    let reqBody = {
      id: null,
      boat: this.boat,
      customer: this.boat.boatCustomers[0].customer,
      sailor: null,
      navigationPlan: event.navigationPlan,
      executionDate: event.executionDate,
      returnTime: event.returnTime,
      objectiveCode: 'NAVIGATION',
      questionnairesAnswer: [],
      observation: event.observation

    };
    let response: any;
    this.movementPlanService.saveByObjective(reqBody).subscribe({
      next: (r) => { response = r},
      error: (err) => { 
            let msg = err.error.data.exception.message;
            if (msg === null || msg === '') {
              msg = 'Não foi possivel inciar navegavcao!';
            }
            this.toastService.error(msg);
          },
      complete: () => { this.finishNavOperation(response);}


//

  });

  }


  finishNavOperation(movPlanResponse: any) {
    let movementPlanId = movPlanResponse.movementPlan.id;
    let movments:any[] = movPlanResponse.movementPlan.movements.filter(m => (m.movementStatus == 'AWAITING_PREPARATION' && m.destinyLocationType == 'NAVIGATION')  );
    let movment;
    if (movments && movments.length > 0) {
      movment = movments[0];
    }




    let executeOperationDTO: ExecuteOperationDTO =  new ExecuteOperationDTO();
    executeOperationDTO.movementPlanId = movementPlanId;
    executeOperationDTO.movementId = movment.id;
    executeOperationDTO.operation = MovementOperation.FINISH;
    let locationFinishDTO: LocationFinishDTO = new LocationFinishDTO();
    locationFinishDTO.movementLocation = new MovementLocation();
    locationFinishDTO.movementLocation.id = 49;
    locationFinishDTO.movementLocation.type = MovementLocationType.NAVIGATION;
    executeOperationDTO.locationFinish = locationFinishDTO;

    this.movimentExecutionService.executeOperation(executeOperationDTO).subscribe({
      next: (r) => {},
      error: (err) =>{},
      complete: () => {
        this.toastService.success("Embarcação em navegação.");
      }

    });


  }



  close(): void {
    this.dialogRef.close();
  }

  previouPage(): void {

  }

  isAlreadyStarted(): boolean {
    return false;
  }

  getFirstEdit(): boolean {
    return true;
  }

 
}